import {
  GET_PAYMENT_FORM,
  UPDATE_PAYMENT_FORM_SAGA,
  DELETE_PAYMENT_FORM_SAGA
} from './actionsTypes';

const actions = {
  initData: () => ({ type: GET_PAYMENT_FORM }),
  updatePaymentForm: paymentForm => {
      return (dispatch, getState) => {
        const paymentForms = getState().PaymentForms.paymentForms;
        const index = paymentForms.map(inv => inv._id).indexOf(paymentForm._id);
        if (index === -1) {
          paymentForms.unshift(paymentForm);
        } else {
          paymentForms[index] = paymentForm;
        }
        dispatch({
          type: UPDATE_PAYMENT_FORM_SAGA,
          paymentForms,
          paymentForm,
        });
      };
  },
  deletePaymentForm: id => {
      return (dispatch, getState) => {
        const paymentForms = getState().PaymentForms.paymentForms;
        const newPaymentForm = [];
        paymentForms.forEach(paymentForm => {
          if (paymentForm._id !== id) {
            newPaymentForm.push(paymentForm);
          }
        });
        dispatch({
          type: DELETE_PAYMENT_FORM_SAGA,
          paymentForms: newPaymentForm,
          paymentForm: id,
        });
      };
  },
};

export default actions;